defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClubCoupons/ClubCoupons',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/TabsSwitch',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClubCoupons/ActiveTab',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClubCoupons/FinishedTab',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClubCoupons/SubscriptionsTab',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Modal',
    'DanskeSpil/Domain/NumberGames/Scripts/Components/Coupon'
  ],
  function (m, PlayTogetherApi, CtaButton, TabsSwitch, ActiveTab, FinishedTab, SubscriptionsTab, Modal, Coupon) {

    // View:
    var Header = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
        this.loading = m.prop(true);
        this.activeCoupons = m.prop([]);
        this.finishedCoupons = m.prop([]);

        // tabs config:
        this.tabsSwitch = [
          {
            value: 'active',
            label: this.clubCouponsDictionary('TabsLabels/Active')
          },
          {
            value: 'subscriptions',
            label: this.clubCouponsDictionary('TabsLabels/Subscriptions')
          },
          {
            value: 'finished',
            label: this.clubCouponsDictionary('TabsLabels/Finished')
          }
        ];
        this.activeTabValue = m.prop(this.tabsSwitch[0].value);

        const couponModal = new Modal();

        this.openCoupon = (couponArgs) => {
          return () => {
            const couponBody = m('div', m(Coupon, {
              controller: couponArgs,
            }));

            couponModal.setContent(couponBody);
            couponModal.show();
          };
        };

        const sortCoupons = (coupons) => {
          if (coupons.length === 0) {
            return [];
          }
          const allCoupons = [];

          for (let i = 0; i < coupons.length; i++) {
            const drawsWithCouponInformation = coupons[i].draws.map((draw) => {
              // eslint-disable-next-line no-unused-vars
              const { draws, ...couponInformation }  =  coupons[i];
              return { ...draw, ...couponInformation };
            });
            allCoupons.push(...drawsWithCouponInformation);
          }

          allCoupons.sort((a, b) => {
            if (a.drawDate === b.drawDate) {
              return b.couponId - a.couponId;
            }

            return new Date(b.drawDate) - new Date(a.drawDate);
          });

          allCoupons.forEach((coupon) => {
            if (coupon.finalized) {
              this.finishedCoupons().push(coupon);
            } else {
              this.activeCoupons().push(coupon);
            }
          });
        };

        PlayTogetherApi.getClubCoupons(this.clubId())
          .then((coupons) => {
            sortCoupons(coupons);
            this.tabsSwitch[0].label = this.clubCouponsDictionary('TabsLabels/Active', { count: this.activeCoupons().length });
            this.loading(false);
            m.redraw();
          });

        this.$couponItem = ({ coupon, drawDetails }) => {
          const gameNameMap = {
            viking: 'vikinglotto'
          };
          const gameName = gameNameMap[coupon.gameType.toLowerCase()] || coupon.gameType.toLowerCase();
          const couponArgs = {
            gameType: coupon.gameType,
            fundingId: coupon.fundingId,
            groupPlayId: coupon.groupPlayId,
            couponId: coupon.couponId
          };

          return m('.play-together-club-coupon-item', {
            onclick: this.openCoupon(couponArgs)
          }, [
            m('.play-together-club-coupon-item__icon', {
              class: gameName
            }, m('svg', m('use', {
              href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#clubCouponIcon'
            }))),
            m('.play-together-club-coupon-item__details', [
              m('.play-together-club-coupon-item__title.play-together-club-coupon-item__title--' + gameName, [
                m('span', gameName),
                coupon.subscriptionGroupGameId ? m('svg', m('use', {
                  href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#infinity'
                })) : null
              ]),
              m('.play-together-club-coupon-item__draw-details', drawDetails)
            ])
          ]);
        };

        this.$noCoupons = ({ title, description }) => {
          return m('.play-together-club-coupon__empty-list', [
            m('svg.play-together-club-coupon__empty-list-icon', m('use', {
              href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#kuponer'
            })),
            m('.play-together-club-coupon__empty-list-title', title),
            m('.play-together-club-coupon__empty-list-description', description)
          ]);
        };
      },
      view: function (controller) {
        const componentArgs = [{ controller }, {
          header: m(TabsSwitch, { controller }),
          footer: controller.showCreatePlayButton() ? CtaButton({
            text: controller.clubCouponsDictionary('CreateNewGameButton'),
            href: controller.navigationPaths.createPlayChooseGamePage + '?klubId=' + controller.clubModelFields().clubId()
          }) : null
        }];
        const tabContent = () => {
          switch (controller.activeTabValue()) {
          case 'finished':
            return m(FinishedTab, ...componentArgs);
          case 'subscriptions':
            return m(SubscriptionsTab, ...componentArgs);
          default:
            return m(ActiveTab, ...componentArgs);
          }
        };
        // View:
        return m('.play-together-club-coupons', [
          tabContent()
        ]);
      }
    };

    // Public functions:
    return Header;

  });
